import { useEffect, useState } from "react";
import axios from "axios";
import { ScrollText } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const utc = (t) => (t ? new Date(t * 1000).toISOString().slice(11, 19) : "—");
const pct = (v) => (v == null ? "—" : `${(v * 100).toFixed(1)}%`);

export const NotificationLog = ({ tick }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    axios.get(`${API}/notifications?limit=25`).then((r) => setRows(r.data.notifications)).catch(() => {});
  }, [tick]);
  return (
    <section className="card p-5 sm:p-6 fade-up" data-testid="notification-log">
      <h2 className="font-head font-bold text-lg flex items-center gap-2"><ScrollText className="w-5 h-5 text-[#22D3EE]" /> Notification audit log</h2>
      <p className="text-xs text-slate-400 mt-1">Every notification decision (sent or suppressed) with the exact data and timestamps it was based on.</p>
      <div className="mt-3 space-y-2 max-h-96 overflow-y-auto">
        {rows.length === 0 && <p className="text-sm text-slate-500">No notification events yet.</p>}
        {rows.map((r, i) => (
          <div key={i} className="rounded-lg border border-[#1A2338] bg-[#0F1A2E] p-3 text-xs" data-testid={`notification-row-${i}`}>
            <div className="flex flex-wrap justify-between gap-2">
              <span className="font-semibold text-slate-200">{r.type.replace(/_/g, " ")} · {r.status || "—"}</span>
              <span className={r.sent ? "text-[#34D399]" : "text-slate-500"}>{r.sent ? "sent" : `not sent${r.suppressed ? ` (${r.suppressed.replace(/_/g, " ")})` : ""}`}</span>
            </div>
            <div className="font-num text-slate-400 mt-1">
              {new Date(r.created_at).toLocaleTimeString()} · model {pct(r.inputs?.model_up)} · market {pct(r.inputs?.market_up)}
              {r.inputs?.price ? ` · BTC $${r.inputs.price.toLocaleString()}` : ""} · book {utc(r.inputs?.book_ts)} · BRTI {utc(r.inputs?.index_ts)} UTC
            </div>
            {r.reason && <div className="text-slate-500 mt-1">{r.reason}</div>}
          </div>
        ))}
      </div>
    </section>
  );
};
